import ObjectsScreen from './ObjectsScreen';

export default ObjectsScreen;
